import Notiflix from 'notiflix'
import { Button, Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'

import styles from './ReleaseForm.module.scss'
import instance from '../../../../../../../providers/axios.config'

interface IProps {
  releases: IReleaseForm[]
}

interface IReleaseForm {
  logo: any
  releaseFormType: string
  pdfReleaseFormType: string
  digitalReleaseFormType: string
  pathPdf?: string
  pathDigital?: string
  name?: string
}

export const ReleaseForm = (props: IProps) => {
  const { t } = useTranslation()

  const handleDownload = async (release: IReleaseForm) => {
    Notiflix.Loading.standard({ svgColor: '#c11b1e' })
    const urlData = `${window.location.origin}/${release.pathPdf}`
    const res = (await instance.get(`${urlData}`, { responseType: 'arraybuffer' })) as any
    let blob = new Blob([res], { type: `application/pdf` }),
      url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${release.name}.pdf`)
    document.body.appendChild(link)
    link.click()
    Notiflix.Loading.remove()
  }

  return (
    <Box className={styles.container}>
      <Box className={styles.header}>
        <DescriptionOutlinedIcon className={styles.headerIcon} />
        <Typography className={styles.title}>{t('Releases Forms')}</Typography>
      </Box>

      <Box className={styles.releasesList}>
        {props.releases.map((itm: IReleaseForm) => (
          <Box key={`release-form-download-${itm.releaseFormType}`} className={styles.releaseItem}>
            <Box className={styles.iconWrapper}>
              <DescriptionOutlinedIcon className={styles.pdfIcon} />
            </Box>
            <Box className={styles.releaseContent}>
              <Typography>{itm.pdfReleaseFormType}</Typography>
              <Typography className={styles.formatLabel}>PDF</Typography>
            </Box>
            <Button
              onClick={() => handleDownload(itm)}
              className={styles.downloadButton}
              startIcon={<FileDownloadOutlinedIcon />}
            >
              {t('Download')}
            </Button>
          </Box>
        ))}
      </Box>
    </Box>
  )
}